import { render, staticRenderFns } from "./Screen.vue?vue&type=template&id=c3c6f1c4&scoped=true"
import script from "./Screen.vue?vue&type=script&lang=js"
export * from "./Screen.vue?vue&type=script&lang=js"
import style0 from "./Screen.vue?vue&type=style&index=0&id=c3c6f1c4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c6f1c4",
  null
  
)

export default component.exports